import axios, { AxiosError } from "axios";

const apiBaseURL = process.env.REACT_APP_API_URL;

// Optional: let the app react to 401s globally (e.g., logout)
let onUnauthorized: (() => void) | null = null;
export function setUnauthorizedHandler(cb: () => void) {
  onUnauthorized = cb;
}

export const api = axios.create({
  baseURL: apiBaseURL,
});

// Attach JWT from localStorage for every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

// Central 401 handling
api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  }
);
